import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
  }, [slug]);

  if (post === null) return <div className="max-w-3xl mx-auto px-6 py-32 text-[#757575]">Loading…</div>;
  if (!post) return (
    <div className="max-w-3xl mx-auto px-6 py-32">
      <p className="font-display text-3xl text-[#212121]">Article not found.</p>
      <Link to="/care" className="btn-secondary mt-6 inline-flex">Back to journal</Link>
    </div>
  );

  // Simple markdown-ish rendering for headings + paragraphs
  const blocks = post.content.split(/\n\n+/);

  return (
    <article data-testid="blog-post" className="max-w-3xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
      <Link to="/care" className="text-[#757575] text-sm uppercase tracking-widest hover:text-[#B87333] font-bold">← Journal</Link>
      <h1 className="font-display text-5xl text-[#212121] mt-8 mb-6 leading-tight">{post.title}</h1>
      {post.cover_image && (
        <img src={post.cover_image} alt="" className="w-full aspect-[16/9] object-cover border border-[#B2DFDB] mb-10" />
      )}
      <div className="prose-content space-y-6 text-[#757575] leading-relaxed">
        {blocks.map((b, i) => {
          if (b.startsWith("## ")) return <h2 key={i} className="font-display text-3xl text-[#212121] mt-10 mb-2">{b.slice(3)}</h2>;
          if (b.startsWith("- ")) return (
            <ul key={i} className="list-disc pl-5 space-y-1">
              {b.split("\n").map((li, j) => <li key={j}>{li.replace(/^-\s*/, "")}</li>)}
            </ul>
          );
          return <p key={i}>{b}</p>;
        })}
      </div>
    </article>
  );
}
